export default __webpack_public_path__ + "static/media/cluster_point_purple.b90a3763.svg";